(() => {
  const productInfo = document.querySelector('product-info[data-product-id]');

  if (!productInfo || productInfo.classList.contains('product-page--mouse-3d')) return;

  const productId = productInfo.dataset.productId;
  const modelJSON = document.getElementById(`ProductJSON-${productId}`);
  let models = [];

  try {
    models = modelJSON ? JSON.parse(modelJSON.textContent || '[]') : [];
  } catch (error) {
    models = [];
  }

  const isAndroidChrome = () => {
    const userAgent = navigator.userAgent || '';
    const androidVersion = userAgent.match(/Android\s+([0-9]+)/i);

    return (
      /Android/i.test(userAgent) &&
      /Chrome\/\d+/i.test(userAgent) &&
      (!androidVersion || Number(androidVersion[1]) >= 7)
    );
  };

  const isDebugPreview = () => new URLSearchParams(window.location.search).get('debug-xr') === 'sv';

  const getButtons = () =>
    [...productInfo.querySelectorAll('button[data-shopify-xr][data-shopify-model3d-id]')].filter(
      (button) =>
        !button.closest('[data-noir-mouse-3d-stage]') && !button.closest('product-modal'),
    );

  const getGlobalButton = () =>
    getButtons().find(
      (button) =>
        button.closest('media-gallery') && !button.closest('.product-media-container'),
    );

  const getModel = (modelId) =>
    models.find((model) => String(model.id) === String(modelId));

  const getGlbSource = (model) => {
    const sources = Array.isArray(model?.sources) ? model.sources : [];
    const glbSource = sources.find((source) => {
      const format = String(source?.format || '').toLowerCase();
      const mimeType = String(source?.mime_type || '').toLowerCase();
      const url = String(source?.url || '').toLowerCase();

      return format === 'glb' || mimeType === 'model/gltf-binary' || /\.glb(?:$|\?)/i.test(url);
    });

    return glbSource?.url || '';
  };

  const buildSceneViewerIntent = (button, model) => {
    const source = getGlbSource(model);

    if (!source) return '';

    const sceneViewerUrl = new URL('https://arvr.google.com/scene-viewer/1.0');
    sceneViewerUrl.searchParams.set('file', new URL(source, window.location.href).href);
    sceneViewerUrl.searchParams.set('link', window.location.href);
    sceneViewerUrl.searchParams.set(
      'title',
      button.dataset.shopifyTitle || document.title,
    );

    const fallbackUrl = `${window.location.href.split('#')[0]}#noir-xr-fallback`;

    return `intent://${sceneViewerUrl.host}${sceneViewerUrl.pathname}${sceneViewerUrl.search}#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url=${encodeURIComponent(fallbackUrl)};end`;
  };

  const hideNonPrimaryDebugButtons = (primaryButton) => {
    getButtons().forEach((button) => {
      if (button === primaryButton) {
        delete button.dataset.noirXrDebugHidden;
        return;
      }

      button.dataset.noirXrDebugHidden = 'true';
    });
  };

  const exposeDebugButton = () => {
    const button = getGlobalButton();

    if (!button) return false;

    hideNonPrimaryDebugButtons(button);
    button.removeAttribute('data-shopify-xr-hidden');
    button.dataset.noirXrDebug = 'true';

    return true;
  };

  const hasNativeVisibleButton = () =>
    getButtons().some((button) => !button.hasAttribute('data-shopify-xr-hidden'));

  const attachAndroidFallback = (button) => {
    if (!button || !button.hasAttribute('data-shopify-xr-hidden')) return true;

    const model = getModel(button.dataset.shopifyModel3dId);
    const intentUrl = buildSceneViewerIntent(button, model);

    if (!intentUrl) return false;
    if (button.dataset.noirAndroidArFallback === 'true') return true;

    button.removeAttribute('data-shopify-xr-hidden');
    button.dataset.noirAndroidArFallback = 'true';
    button.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.href = intentUrl;
      },
      true,
    );

    return true;
  };

  const enableAndroidFallback = () => {
    if (!isAndroidChrome() || hasNativeVisibleButton()) return false;

    return attachAndroidFallback(getGlobalButton());
  };

  const start = () => {
    if (isDebugPreview()) {
      exposeDebugButton();
      document.addEventListener(
        'shopify_xr_initialized',
        () => window.setTimeout(exposeDebugButton, 350),
        { once: true },
      );
      window.setTimeout(exposeDebugButton, 900);
    }

    if (!isAndroidChrome()) return;

    const runAndroidFallback = () => {
      if (hasNativeVisibleButton()) return;
      enableAndroidFallback();
    };

    document.addEventListener(
      'shopify_xr_initialized',
      () => window.setTimeout(runAndroidFallback, 350),
      { once: true },
    );
    window.setTimeout(runAndroidFallback, 2500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
